<form (ngSubmit)="onSubmit()" #form="ngForm" column-classes="col-md-2,col-md-4,col-md-6">
  <cap-content-header>
    <cap-title>
      {{ ("meldungsempfaenger.detail" | translate) + " " + (writeModel.bezeichnung || "") }}
    </cap-title>
    <cap-title-functionbar>
      @if (isReadOnlyMode()) {
        <button (click)="onEdit()" class="btn btn-outline-primary btn-sm me-2" type="button">
          <i class="fas fa-pen me-2"></i>{{ "functionbar.edit" | translate }}
        </button>
      }
      @if (isEditMode() || isNewMode()) {
        <button (click)="onCancel()" class="btn btn-outline-primary btn-sm me-2" type="button">
          <i class="fas fa-times me-2"></i>{{ "functionbar.cancel" | translate }}
        </button>
      }
      <span [ngbTooltip]="(writeModel.hasMeldungen ? 'meldungsempfaenger.hasMeldungen' : '') | translate" placement="left">
        @if (isReadOnlyMode() || isEditMode()) {
          <button (click)="onDelete()" [disabled]="writeModel.hasMeldungen" class="btn btn-outline-primary btn-sm me-2" type="button">
            <i class="fas fa-trash me-2"></i>{{ "functionbar.delete" | translate }}
          </button>
        }
      </span>
      @if (isEditMode() || isNewMode()) {
        <button [disabled]="!form.valid" class="btn btn-primary btn-sm" type="submit">
          <i class="fas fa-check me-2"></i>{{ "functionbar.save" | translate }}
        </button>
      }
    </cap-title-functionbar>
  </cap-content-header>
  <fieldset [disabled]="isReadOnlyMode()" class="mt-2">
    <cap-form-row column-classes="col-md-2,col-md-4,col-md-6">
      <cap-form-control invalidKey="meldungsempfaenger.bezeichnung.invalid" labelKey="meldungsempfaenger.bezeichnung">
        <input
          [(ngModel)]="writeModel.bezeichnung"
          [maxLength]="255"
          #bezeichnungInput
          appAutofocus
          id="bezeichnung"
          name="bezeichnung"
          required
          type="text" />
      </cap-form-control>
      <div class="col input-group mb-1">
        <div class="input-group-text">
          <input [(ngModel)]="writeModel.erhaeltMeldungen" id="erhaeltmeldungen" name="erhaeltmeldungen" type="checkbox" />
        </div>
        <label class="form-control" for="erhaeltmeldungen">
          {{ "meldungsempfaenger.erhaeltmeldungen" | translate }}
        </label>
      </div>
    </cap-form-row>
    <cap-form-row column-classes="col-md-2,col-md-4,col-md-6">
      <cap-form-control invalidKey="meldungsempfaenger.sedexid.invalid" labelKey="meldungsempfaenger.sedexid">
        <input
          [(ngModel)]="writeModel.sedexId"
          [disabled]="writeModel.meldungsEmpfaengerId?.id !== ''"
          [maxLength]="255"
          #sedexIdInput
          id="sedexid"
          name="sedexid"
          pattern="^(T?[1-9]-[0-9A-Z]+-[0-9]+|T?0-sedex-[0-9])$"
          placeholder="1-ABC-2"
          required
          type="text" />
      </cap-form-control>
      <div class="col input-group mb-1">
        <div class="input-group-text">
          <input
            [(ngModel)]="writeModel.erhaeltVertraulicheDaten"
            id="erhaeltVertraulicheDaten"
            name="erhaeltVertraulicheDaten"
            type="checkbox" />
        </div>
        <label class="form-control" for="erhaeltVertraulicheDaten">
          {{ "meldungsempfaenger.erhaeltVertraulicheDaten" | translate }}
        </label>
      </div>
    </cap-form-row>

    <cap-form-row column-classes="col-md-2,col-md-4,col-md-6">
      <div class="col input-group mb-1"></div>
      <div class="col input-group mb-1 float-end">
        <div class="input-group-text">
          <input [(ngModel)]="writeModel.erhaeltBasedelivery" id="erhaeltBaseDelivery" name="erhaeltBaseDelivery" type="checkbox" />
        </div>
        <label class="form-control" for="erhaeltBaseDelivery">
          {{ "meldungsempfaenger.erhaeltBaseDelivery" | translate }}
        </label>
      </div>
    </cap-form-row>

    <cap-form-row column-classes="col-md-6,col-md-6">
      <div class="col-md-6">
        <cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-meldungsempfaenger-ereignisse">
          <ng-container title>
            <h3>{{"meldungsempfaenger.ereignisse" | translate}}</h3>
          </ng-container>
          <div titleActionButtons>
            @if (isEditMode() || isNewMode()) {
              <div class="input-group-text">
                <input
                  (click)="toggleAllEreignissCheckBox($event)"
                  [checked]="containsAllEreignisse()"
                  [ngbTooltip]="'select.all' | translate"
                  placement="bottom"
                  type="checkbox" />
              </div>
            }
          </div>
          @for (enum of ereignisseEnums(); track enum) {
            <div class="input-group mb-1 mt-2">
              <label [attr.for]="'meldungsempfaenger.ereignisse.' + enum" class="form-control">
                {{ translateEreigniss(enum) }}
              </label>
              <div class="input-group-text">
                <input
                  (click)="toggleEreignissCheckBox($event, enum)"
                  [checked]="writeModel.registriertAufEreignisse.includes(enum)"
                  [id]="'meldungsempfaenger.ereignisse.' + enum"
                  type="checkbox" />
              </div>
            </div>
          }
        </cap-rubrik>
      </div>
      <div class="col-md-6">
        <cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-meldungsempfaenger-gemeinde">
          <ng-container title>
            <h3>{{"meldungsempfaenger.gemeinde" | translate}}</h3>
          </ng-container>
          @if (!isReadOnlyMode()) {
            <input
              (selectItem)="onGemeindeSelect($event)"
              [inputFormatter]="inputFormatter"
              [ngbTypeahead]="searchGemeinden"
              [resultFormatter]="resultFormatter"
              #gemeindeSearch
              class="form-control"
              type="search" />
          }
          <table class="table table-striped table-hover table-sm bsg-table gemeinde-completer mb-0 mt-2">
            <tbody>
              @for (gemeinde of writeModel.eingeschraenktAufGemeinden; track gemeinde) {
                <tr>
                  <td class="w-75">{{ gemeinde.bfsNummer }} {{ gemeinde.name }}</td>
                  <td class="w-25 text-end">
                    @if (!isReadOnlyMode()) {
                      <button
                        (click)="removeGemeinde(gemeinde)"
                        [ngbTooltip]="'functionbar.delete' | translate"
                        class="btn btn-danger btn-sm"
                        placement="bottom"
                        type="button">
                        <i class="fas fa-trash"></i>
                      </button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </cap-rubrik>
      </div>
    </cap-form-row>
  </fieldset>
</form>
